export const PointMoneyDisableCase = {
    POINT_MONEY_NOT_AVAILABLE: 'POINT_MONEY_NOT_AVAILABLE',
    MONEY_ONLY_MONEY_NOT_AVAILABLE: 'MONEY_ONLY_MONEY_NOT_AVAILABLE',
    PAYMENT_SERVICE_REJECTED: 'PAYMENT_SERVICE_REJECTED',
    MONEY_ONLY_MONEY_PAYMENT_SERVICE_REJECTED: 'MONEY_ONLY_MONEY_PAYMENT_SERVICE_REJECTED',
    FAILED_TO_GET_POINT_MONEY_AMOUNT: 'FAILED_TO_GET_POINT_MONEY_AMOUNT',
    MONEY_ONLY_TRANSFER_FAILED: 'MONEY_ONLY_TRANSFER_FAILED',
} as const
